import {createBrowserRouter, RouterProvider} from "react-router-dom";
// 페이지 목록
import Home from "./Pages/Home";
import Layouts from "./Pages/Layouts";
import UsageGuide from "./Pages/Menu1/UsageGuide";
import PricingGuide from "./Pages/Menu1/PricingGuide";
import GroupGuide from "./Pages/Menu1/GroupGuide";
import Location from "./Pages/Menu1/Location";
import GuideMap from "./Pages/Menu2/GuideMap";
import NaturePool from "./Pages/Menu2/NaturePool";
import Program from "./Pages/Menu3/Program";
import Museum from "./Pages/Menu3/Museum";
import Permanent from "./Pages/Menu3/Permanent";
import Special from "./Pages/Menu3/Special";
import Sports from "./Pages/Menu3/Sports";
import Notice from "./Pages/Menu4/Notice";
import Announcement from "./Pages/Menu4/Announcement";
import Campaign from "./Pages/Menu4/Campaign";
import Dstory from "./Pages/Menu4/Dstory";
import Faq from "./Pages/Menu4/Faq";
import Terms from "./Pages/Member/Terms";
import Policy from "./Pages/Member/Policy";
import WalkPath from "./Pages/Menu2/WalkPath";
import Playground from "./Pages/Menu2/Playground";
import Facility from "./Pages/Menu2/Facility";
import FoodCourt from "./Pages/Menu2/FoodCourt";
import NaturePoolGuide from "./Pages/Menu2/NaturePoolGuide";
import NaturePoolFacility from "./Pages/Menu2/NaturePoolFacility";
import Detail from "./Pages/Menu3/Detail";
import MuseumInfo from "./Pages/Menu3/MuseumInfo";
import MuseumSpecial from "./Pages/Menu3/MuseumSpecial";
import MuseumPast from "./Pages/Menu3/MuseumPast";
import MuseumPermanent from "./Pages/Menu3/MuseumPermanent";
import ErrorBoundary from "./Pages/ErrorBoundary";


const Router = () => {
    return <RouterProvider router={router}/>;
};

const router = createBrowserRouter([
    {
        path: "/",
        element: <Layouts/>,
        errorElement : <ErrorBoundary/> ,
        children: [
            { path: "", element: <Home /> },
            {
                path: "guide",
                children: [
                    { path: "", element: <UsageGuide /> },
                    { path: "price", element: <PricingGuide /> },
                    { path: "group", element: <GroupGuide /> },
                    { path: "location", element: <Location /> },
                ],
            },
            {
                path: "map",
                children: [
                    { path: "", element: <GuideMap /> },
                    { path: "naturepool", element: <NaturePool /> },
                    { path: "naturepool/guide", element: <NaturePoolGuide /> },
                    { path: "naturepool/facility", element: <NaturePoolFacility /> },
                    { path: "museum", element: <MuseumInfo /> },
                    { path: "walkpath", element: <WalkPath /> },
                    { path: "playground", element: <Playground /> },
                    { path: "facility", element: <Facility /> },
                    { path: "foodcourt", element: <FoodCourt /> },
                ],
            },
            {
                path: "program/museum",
                children: [
                    { path: "", element: <Museum /> },
                    { path: "permanent", element: <MuseumPermanent /> },
                    { path: "special", element: <MuseumSpecial /> },
                    { path: "past", element: <MuseumPast /> },
                    { path: ":boardType/:id", element: <Detail /> },
                ]
            },
            {
                path: "program",
                children: [
                    { path: "", element: <Program /> },
                    { path: "permanent", element: <Permanent /> },
                    { path: "special", element: <Special /> },
                    { path: "dogsports", element: <Sports /> },
                    { path: ":boardType/:id", element: <Detail /> },
                ],
            },
            {
                path: "notice",
                children: [
                    { path: "", element: <Notice /> },
                    { path: "announcement", element: <Announcement /> },
                    { path: "campaign", element: <Campaign /> },
                    { path: "dstory", element: <Dstory /> },
                    { path: "faq", element: <Faq /> },
                    { path: ":boardType/:id", element: <Detail /> },
                ],
            },
            { path: "terms", element: <Terms /> },
            { path: "policy", element: <Policy /> },
        ],
    },
]);

export default Router;
